var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-overlay',{attrs:{"z-index":_vm.zIndex,"opacity":".6"}},[_c('h3',{staticClass:"text-center mb-5 white--text"},[_vm._v(_vm._s(_vm.message))]),_c('v-progress-linear',{attrs:{"indeterminate":"","color":"white","rounded":"","height":"6"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }